// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"720":"e7350226","908":"ee95ac13"}[chunkId] + ".chunk.js";
};